/* eslint-disable no-underscore-dangle */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import Badge from '@material-ui/core/Badge';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import IconButton from '@material-ui/core/IconButton';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import Typography from '@material-ui/core/Typography';
import SchoolIcon from '@material-ui/icons/School';
import Assessment from '@material-ui/icons/Assessment';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import Dashboard from '@material-ui/icons/Dashboard';
import Help from '@material-ui/icons/Help';
import BallotIcon from '@material-ui/icons/Ballot';
import LoopIcon from '@material-ui/icons/Loop';
import Timer from '@material-ui/icons/Timer';
import LaptopChromebook from '@material-ui/icons/LaptopChromebook';
import MenuBook from '@material-ui/icons/MenuBook';
import VideoLibrary from '@material-ui/icons/VideoLibrary';
import CastForEducation from '@material-ui/icons/CastForEducation';
import AllInbox from '@material-ui/icons/AllInbox';
import CloudDownload from '@material-ui/icons/CloudDownload';
import FolderSharedIcon from '@material-ui/icons/FolderShared';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Collapse from '@material-ui/core/Collapse';
import { Exposure, FolderShared } from '@material-ui/icons';
import { connect } from 'react-redux';
import MenuItem from './MenuItem';
import { toulouseSchools } from '../../../helpers/utils';
import { companyServices } from '../../../redux/services/companyServices';
import { groupActions } from '../../../redux/actions/groupActions';

const useStyles = makeStyles((theme) => ({
  drawerContainer: {
    overflow: 'auto',
  },
  drawerHeader: {
    display: 'flex',
    flexGrow: 1,
    alignItems: 'center',
    paddingLeft: '1em',
    ...theme.mixins.toolbar,
  },
  menuTitle: {
    fontFamily: 'Roboto',
    color: '#0000008a',
  },
  menuCategories: {
    fontSize: '1.25rem',
    fontFamily: 'Roboto',
    lineHeight: 1.6,
    color: '#0000008a',
  },
}));

const MenuCustomerMW = ({
  handleDrawerClose, company, getAll, groups,
}) => {
  const classes = useStyles();
  const [openMenu, setOpenMenu] = useState({
    elearning: false,
    students: false,
    results: false,
    webinaires: false,
  });
  const [isSubGroups, setIsSubGroups] = useState(false);
  const [badgeNb, setBadgeNb] = useState(0);

  const toggleMenu = (menu) => {
    setOpenMenu((prev) => ({ ...prev, [menu]: !prev[menu] }));
  };

  const loadData = async () => {
    let exports = [];
    if (company && company._id) {
      exports = await companyServices.getCompanyExports(company._id);
    }
    let res = 0;
    const limitDate = new Date();
    limitDate.setMonth(limitDate.getMonth() - 1);
    exports.forEach((test) => {
      const creation = new Date(test.created_at);
      if (creation > limitDate) {
        res += 1;
      }
    });
    setBadgeNb(res);
  };

  useEffect(() => {
    if (groups) {
      Object.keys(groups).forEach((i) => {
        if (groups[i].elearning.subGroups && groups[i].elearning.subGroups !== null) {
          setIsSubGroups(true);
        }
      });
    }
  }, [groups]);

  useEffect(() => {
    if (company) {
      getAll(company._id);
    }
    loadData();
  }, [company]);

  return (
    <div className={classes.drawerContainer}>
      <div className={classes.drawerHeader}>
        <IconButton
          onClick={handleDrawerClose}
          aria-label="Dérouler"
        >
          <ChevronLeftIcon />
        </IconButton>
        <Grid container>
          <Grid item md={12}>
            <Typography component="p" variant="body1" className={classes.menuTitle}>
              {company && company.name}
            </Typography>
          </Grid>
        </Grid>
      </div>
      <Divider />

      <List>
        {/* Tableau de bord */}
        <ListItem component={Link} to="/home" button>
          <ListItemIcon><Dashboard /></ListItemIcon>
          <ListItemText primary="Tableau de bord" />
        </ListItem>

        {/* Mes informations */}
        {(company && !toulouseSchools.includes(company._id)) && (
          <ListItem component={Link} to="/informations" button>
            <ListItemIcon><BallotIcon /></ListItemIcon>
            <ListItemText primary="Mes informations" />
          </ListItem>
        )}

        {/* Gestion des étudiants (menu déroulant) */}
        <Divider />
        <ListItem button onClick={() => toggleMenu('students')}>
          <ListItemIcon><AssignmentIndIcon /></ListItemIcon>
          <ListItemText primary="Gestion des étudiants" />
          {openMenu.students ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={openMenu.students} timeout="auto" unmountOnExit>
          <List component="div" style={{ marginLeft: '5%', width: '95%' }}>
            <MenuItem name={`Liste des ${company && company.isCompany ? 'stagiaires' : 'étudiants'}`} route="/test" icon={<AssignmentIndIcon />} />
            <MenuItem name="Rattrapages" route="/catchup" icon={<FolderSharedIcon />} />
            <MenuItem name="Redoublements" route="/repeat" icon={<LoopIcon />} />
            <MenuItem name="Tiers-Temps" route="/additionalTime" icon={<Timer />} />
          </List>
        </Collapse>

        {/* E-learning */}
        <Divider />
        <ListItem button onClick={() => toggleMenu('elearning')}>
          <ListItemIcon><LaptopChromebook /></ListItemIcon>
          <ListItemText primary="E-learning" />
          {badgeNb > 0 && !openMenu.elearning && (
            <IconButton
              aria-label="Voir notifications"
              color="inherit"
            >
              <Badge badgeContent={badgeNb} color="secondary" />
            </IconButton>
          )}
          {openMenu.elearning ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={openMenu.elearning} timeout="auto" unmountOnExit>
          <List component="div" style={{ marginLeft: '5%', width: '95%' }}>
            <MenuItem name="Suivi E-learning" route="/group" icon={<SchoolIcon />} />
            {isSubGroups && <MenuItem name="Sous Groupes" route="/subgroups" icon={<AllInbox />} />}
            <MenuItem name="Contenu" route="/elearning" icon={<CastForEducation />} />
            <MenuItem name="Ressources" route="/resources" icon={<MenuBook />} />
            <MenuItem name="Tutoriels" route="/tutorials" icon={<VideoLibrary />} />
          </List>
        </Collapse>

        {/* Résultats (menu déroulant) */}
        <Divider />
        <ListItem button onClick={() => toggleMenu('results')}>
          <ListItemIcon><Assessment /></ListItemIcon>
          <ListItemText primary="Résultats" />
          {openMenu.results ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={openMenu.results} timeout="auto" unmountOnExit>
          <List component="div" style={{ marginLeft: '5%', width: '95%' }}>
            <MenuItem name="E-learning" route="/exports" icon={<Assessment />} />
            <MenuItem name="Examens" route="/results" icon={<CloudDownload />} />
            <MenuItem name="Pondération" route="/ponderation" icon={<Exposure />} />
          </List>
        </Collapse>

        {/* Documents */}
        <Divider />
        <ListItem component={Link} to="/documents" button>
          <ListItemIcon><FolderShared /></ListItemIcon>
          <ListItemText primary="Documents" />
        </ListItem>

        {/* Webinaires (menu déroulant) */}
        <Divider />
        <ListItem button onClick={() => toggleMenu('webinaires')}>
          <ListItemIcon><LaptopChromebook /></ListItemIcon>
          <ListItemText primary="Webinaires" />
          {openMenu.webinaires ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={openMenu.webinaires} timeout="auto" unmountOnExit>
          <List component="div" style={{ marginLeft: '5%', width: '95%' }}>
            <MenuItem name="À venir" route="/webinaires/InComming" icon={<CastForEducation />} />
            <MenuItem name="Replay" route="/webinaires/Replay" icon={<SchoolIcon />} />
          </List>
        </Collapse>

        {/* Assistance */}
        <Divider />
        <ListItem component={Link} to="/help" button>
          <ListItemIcon><Help /></ListItemIcon>
          <ListItemText primary="Assistance" />
        </ListItem>
      </List>
    </div>
  );
};

MenuCustomerMW.propTypes = {
  handleDrawerClose: PropTypes.func.isRequired,
};

function mapState(state) {
  const { company } = state.company;
  const { groups } = state.group;
  return { company, groups };
}

const actionCreators = {
  getAll: groupActions.getAll,
};

const connectedMenuCustomerMW = connect(mapState, actionCreators)(MenuCustomerMW);
export default connectedMenuCustomerMW;
